// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import app from './app'
import router from './router'
import ElementUI from 'element-ui'
import BaiduMap from 'vue-baidu-map'
import store from './store.js'
import VueCookies from 'vue-cookies'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/iconfont.css'
import '@/assets/css/style.css'
import hljs from 'highlight.js';
import 'highlight.js/styles/googlecode.css' //样式文件
//代码高亮显示组件
Vue.directive('highlight', function (el) {
  let blocks = el.querySelectorAll('pre code');
  setTimeout(() => {
    blocks.forEach((block) => {
      hljs.highlightBlock(block)
    })
  }, 200)
})
//自定义指令，控制按钮
Vue.directive('has', {
  bind: function (el, binding) {
    var btns = sessionStorage.getItem("btns")
    var btnArr = JSON.parse(btns)
    if (btnArr.indexOf(binding.value) == -1 && el.parentNode) {
      el.parentNode.removeChild(el);

    }
  },
  inserted: function (el, binding) {
    var btns = sessionStorage.getItem("btns")
    var btnArr = JSON.parse(btns)
    if (btnArr.indexOf(binding.value) == -1) {
      el.parentNode.removeChild(el);
    }
  }
});
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueCookies)

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'ABUgSPledr9GU1XTjweeVXUqviqEpA6n'
})
//全局函数
//返回按钮，通过面包屑去返回
Vue.prototype.goBack = function () {
  let query = {}
  if (this.$route.meta.routeList[this.$route.meta.routeList.length - 2].query.id) {
    query.id = this.$route.meta.routeList[this.$route.meta.routeList.length - 2].query.id
  } else if (this.$route.meta.routeList[this.$route.meta.routeList.length - 2].query.id && this.$route.meta.routeList[this.$route.meta.routeList.length - 2].query.flag) {
    query.id = this.$route.meta.routeList[this.$route.meta.routeList.length - 2].query.id
    query.flag = this.$route.meta.routeList[this.$route.meta.routeList.length - 2].query.flag
  } else {
    query = null
  }
  if (!(this.$route.meta.routeList[this.$route.meta.routeList.length - 2].name)) {
    this.$router.push({
      name: "首页",
    })
    return
  }
  this.$router.push({
    name: this.$route.meta.routeList[this.$route.meta.routeList.length - 2].name, //最后一个（减1）是当前页，返回按钮要返回到当前页的上一页，所以是减2
    query: query
  });
}
Vue.prototype.checkPassword = function (val) {
  //取字符串长度
  var l = val.length
  var f = function (x, s) { //正则表达式判断函数
    return ((eval('/' + x + '/').test(s)) ? 1 : 0)
  }
  var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]")
  //求和获得4种密码字符组合方式
  var z = f('[0-9]', val) + f('[a-z]', val) + f('[A-Z]', val) + (flag.test(val) ? 1 : 0)
  //只有一种组合情况下长度10位以上才加权重 --避免0123456789这种弱密码
  var r = (l >= 6 && z == 1) ? z + 1 : z;
  //任何组合情况下但有多个重复字符串或者存在admin,root,password,123456等减权重
  if (r > 1 && (f('^(?:(\\w+)\\1+)+$|(\\w)\\2{2,}', val) || f("admin", val) || f("root", val) || f("password", val) || f("123456", val))) r--;
  //一种组合13位或以上，2种组合长度10位或3种组合以上8位  加权重
  if ((l > 5 && z == 2) || (l > 7 && z > 2)) r++;
  //长度14位或以上再加权重
  if (l > 9 && z > 2 && r < 5) r++
  return r;
}
//监听sessionStorage中新手引导步骤
Vue.prototype.changeNoviceGuideStep = function (key, newVal) {
  if (key === 'noviceGuideStep') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('changeNoviceGuideStep', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}

Vue.component('footer-copyright', {
  template: '<p class="footer-msg">©CopyRight 2019-2020 **********有限公司 版权所有 <a href="#" target="_blank">粤ICP备******号</a></p>'
});

Vue.filter('formatDateTime', function (value) {
  if (!value) return ''
  let date = new Date(value);
  let y = date.getFullYear() + '/';
  let mon = (date.getMonth() + 1) + '/';
  let d = date.getDate();
  return y + mon + d;
});


new Vue({
  router,
  store,
  el: '#app',
  render: h => h(app)
})



// WEBPACK FOOTER //
// ./src/main.js